





import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/21-30/blockType21';

const defaultSettings = {
  className: '',
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend();
